import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WeddingsHub from './pages/WeddingsHub';
import PrivateTour from './pages/PrivateTour';
import Investment from './pages/Investment';
import GalleryPage from './pages/GalleryPage';
import FaqPage from './pages/FaqPage';
import EventsHub from './pages/EventsHub';
import CouplesRegion from './pages/CouplesRegion';
import SeoTemplatePage from './pages/SeoTemplatePage';
import ThankYouPage from './pages/ThankYouPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import WeddingAvailability from './pages/WeddingAvailability';
import ScrollToTop from './components/ScrollToTop';

function AppContent() {
  const { pathname } = useLocation();
  const isAvailabilityCampaign = pathname === '/wedding-availability';

  return (
    <div className="font-sans text-brand-charcoal bg-brand-vintage overflow-x-hidden selection:bg-brand-olive selection:text-white">
      <ScrollToTop />
      {!isAvailabilityCampaign && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* Main Wedding Pages */}
        <Route path="/weddings" element={<WeddingsHub />} />
        <Route path="/weddings/private-tour" element={<PrivateTour />} />
        <Route path="/weddings/investment" element={<Investment />} />
        <Route path="/weddings/gallery" element={<GalleryPage />} />
        <Route path="/weddings/faq" element={<FaqPage />} />

        {/* Paid Search Campaign */}
        <Route path="/wedding-availability" element={<WeddingAvailability />} />

        {/* SEO Wedding Feature Pages */}
        <Route path="/weddings/ceremony" element={<SeoTemplatePage pageId="ceremony" />} />
        <Route path="/weddings/reception" element={<SeoTemplatePage pageId="reception" />} />
        <Route path="/weddings/food-and-catering" element={<SeoTemplatePage pageId="food-and-catering" />} />
        <Route path="/weddings/spanish-revival-venue" element={<SeoTemplatePage pageId="spanish-revival-venue" />} />
        <Route path="/weddings/private-estate-wedding-venue" element={<SeoTemplatePage pageId="private-estate-wedding-venue" />} />

        {/* LOCATION SEO HUBS - The "Big 4" Authority Pages */}
        <Route path="/where-our-couples-come-from" element={<CouplesRegion />} />
        <Route path="/inland-empire-wedding-venue" element={<SeoTemplatePage pageId="hub-inland-empire" />} />
        <Route path="/pasadena-wedding-venue" element={<SeoTemplatePage pageId="hub-pasadena" />} />
        <Route path="/orange-county-wedding-venue" element={<SeoTemplatePage pageId="hub-orange-county" />} />
        <Route path="/los-angeles-wedding-venue" element={<SeoTemplatePage pageId="hub-los-angeles" />} />

        {/* Legacy Cannibalization Redirects - Concentrating Authority */}
        <Route path="/wedding-venue/claremont" element={<Navigate to="/" replace />} />
        <Route path="/wedding-venue/pasadena" element={<Navigate to="/pasadena-wedding-venue" replace />} />
        <Route path="/orange-county-couples" element={<Navigate to="/orange-county-wedding-venue" replace />} />
        <Route path="/los-angeles-couples" element={<Navigate to="/los-angeles-wedding-venue" replace />} />

        {/* Legacy Thin City Pages Redirected to the IE Hub */}
        <Route path="/wedding-venue/rancho-cucamonga" element={<Navigate to="/inland-empire-wedding-venue" replace />} />
        <Route path="/wedding-venue/upland" element={<Navigate to="/inland-empire-wedding-venue" replace />} />
        <Route path="/wedding-venue/ontario" element={<Navigate to="/inland-empire-wedding-venue" replace />} />

        {/* Events Pages */}
        <Route path="/events" element={<EventsHub />} />
        <Route path="/events/corporate" element={<SeoTemplatePage pageId="corporate" />} />
        <Route path="/events/private-events" element={<SeoTemplatePage pageId="private-events" />} />
        <Route path="/events/quinceaneras" element={<SeoTemplatePage pageId="quinceaneras" />} />

        {/* Legal / Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Funnel Endpoints */}
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* Catch-all for dynamic SEO slugs */}
        <Route path="/weddings/:slug" element={<SeoTemplatePage />} />
        <Route path="/events/:slug" element={<SeoTemplatePage />} />
      </Routes>
      {!isAvailabilityCampaign && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;